import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './UserMenu.css';

const roleLabels: Record<string, string> = {
  admin: 'Administrator',
  editor: 'Bearbeiter',
  viewer: 'Betrachter',
};

const UserMenu: React.FC = () => {
  const { user, isLoading, isAuthenticated, logout, role } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isLoading || !isAuthenticated || !user) {
    return null;
  }

  const profile = user.profile;
  const displayName = profile?.name || profile?.preferred_username || profile?.email || 'Benutzer';
  const email = profile?.email || '';

  const initials = displayName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="user-menu" ref={menuRef}>
      <button
        className="user-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span className="user-avatar">{initials}</span>
        <span className="user-name">{displayName}</span>
        <span className="user-menu-arrow">{isOpen ? '\u25B2' : '\u25BC'}</span>
      </button>

      {isOpen && (
        <div className="user-menu-dropdown">
          <div className="user-menu-header">
            <div className="user-menu-email">{email}</div>
            <div className="user-menu-role">
              <span className={`role-badge role-${role}`}>{roleLabels[role]}</span>
            </div>
          </div>
          <div className="user-menu-divider" />
          <button className="user-menu-item logout" onClick={logout}>
            Abmelden
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
